import { OWebApp } from "oweb";
import app from "@/app";
import { OZUser, SXCompany } from "@/gobl.bundle";
import ServiceStore from "./default";

export default class UsersStore extends ServiceStore<OZUser> {
	private busy = false;
	private user_data_cb: any[] = [];

	constructor(app: OWebApp) {
		super(app, OZUser, "users");
		this.scheduleLoad(1000);
	}

	scheduleLoad(time: number = 5000, dialog: boolean = true) {
		let m = this;
		let timer = setInterval(function () {
			if (app.userVerified()) {
				clearInterval(timer);
				m.loadCurrentUserData(undefined, false, dialog);
			}
		}, time);
	}

	isAdmin() {
		let infos = this.userInfos();
		return infos && infos[ "is_admin" ];
	}

	isCompanyAdmin(companyId: string) {
		if (this.isAdmin()) {
			return true;
		}

		let company = app.services.companies.identify(companyId);
		let user = app.user.getCurrentUser();

		return company && user && company.owner_id === user.id;
	}

	userInfos() {
		let user = app.user.getCurrentUser();
		return user && this.itemRelation<any>(user, "infos") || {};
	}

	loadCurrentUserData(then?: (success: boolean) => void, freeze: boolean = true, dialog: boolean = true) {

		then && this.user_data_cb.push(then);

		if (!this.busy) {
			this.busy = true;
			let m = this,
				user: OZUser = app.user.getCurrentUser();

			this.get(user.getId(), "infos", function () {
				m.runCb(true);
				m.busy = false;
				m.scheduleLoad(60000, false);
			}, function () {
				m.runCb(false);
				m.busy = false;
				m.scheduleLoad(10000, false);
			}, freeze, false, dialog);
		} else {
			console.warn("[UsersStore] busy!");
		}
	}

	private runCb(success: boolean) {
		this.user_data_cb.forEach((fn) => fn(success));
		this.user_data_cb = [];
	}
}
